import { boolean, object } from "yup"

export const cryptocurrencyTradingOptInSchema = object({
  optInToCryptoTrading: boolean().required(),
  agreedToZhAgreements: boolean().when("optInToCryptoTrading", {
    is: true,
    then: (schema) => schema.required().oneOf([true]),
    otherwise: (schema) => schema.optional(),
  }),
  agreedToDocuments: boolean().when("optInToCryptoTrading", {
    is: true,
    then: (schema) => schema.required().oneOf([true]),
    otherwise: (schema) => schema.optional(),
  }),
})
